/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dizzy_Teal_Ray_EmpowerInputs */

const fr_dizzy_teal_ray_empower = /** @type {(inputs: Dizzy_Teal_Ray_EmpowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmes`)
};

/**

* @param {Dizzy_Teal_Ray_EmpowerInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dizzy_teal_ray_empower = /** @type {((inputs?: Dizzy_Teal_Ray_EmpowerInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dizzy_Teal_Ray_EmpowerInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dizzy_teal_ray_empower(inputs)
});